import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const LazySpaceHoverPageCard: LoadableType<{
	showHoverPageCardForItem: {
		itemID: string | null;
		trigger: React.RefObject<HTMLDivElement> | null;
	};
	closeAllHoverPageCards: () => void;
	clearHoverPageCardTimers: () => void;
	startCloseHoverPageCardTimer: () => void;
	onBlurHoverTarget: (e: any) => void;
	shouldUseAutomationDiscovery?: boolean;
	analyticsSource?: string;
	placement?: 'right-middle' | 'bottom-start';
}> = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-SpaceHoverPageCard" */ './SpaceHoverPageCard.tsx'))
			.SpaceHoverPageCard,
});
